import React, { useContext } from 'react'
import filterMaxCharacterCount from '../../../../utilities/filterMaxCharacterCount'
import { ItemCardManger } from '@components/Cards/BidItem'
import classNames from 'classnames'

const Title = ({ className = '' }: { className?: string }) => {
  const {
    item: { title },
    options: { isSimplified },
  } = useContext<any>(ItemCardManger)
  return (
    <h4
      className={classNames(
        `font-bold ${
          isSimplified ? '' : 'mb-1 md:mb-2 '
        }text-15 xl:text-sm xl:leading-5 line-clamp-2 ${
          title && filterMaxCharacterCount(title, 24) ? 'break-all' : ''
        }`,
        className
      )}
      title={title}
    >
      {title}
    </h4>
  )
}

export default Title
